import React from 'react';
import { BoundSearchQuery } from "../../../types/common/BoundSearchQuery";
import { AdminSpaceUtilizationCriteria } from "../../../types/model/criteria/spaceUtilizationCriteria/AdminSpaceUtilizationCriteria";
import { PageableParams } from "../../../types/model/params/PageableParams";
import { optionsEndpoints } from "../../../requests/api-endpoints";
import {
  SortFilterContainer,
  SortFilterItemContainer,
  SortFilterRowContainer
} from "../../common/reports/sortFilter";
import {
  sortByFields,
  AdminSpaceUsageSortByType,
  AdminSpaceUsageSortParams
} from "../../../types/model/params/sortParams/AdminSpaceUsageSortParams";
import {
  BoundSortSelect,
  BoundDataDrivenAutocomplete,
  BoundDatePicker,
  BoundTextInput,
  BoundDurationTypeSelect
} from "../../common/inputs/boundInputs";

export interface AdminSpaceUsageSearchParams extends AdminSpaceUtilizationCriteria, AdminSpaceUsageSortParams, PageableParams, BoundSearchQuery {}

export interface AdminSpaceUsageSortFilterProps {
  query: AdminSpaceUsageSearchParams;
  onChange: (newQuery: AdminSpaceUsageSearchParams) => void;
}

const AdminSpaceUsageSortFilter = ({
  query,
  onChange
}: AdminSpaceUsageSortFilterProps) => {

  return <SortFilterContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<AdminSpaceUsageSearchParams>
          label="Location"
          requestUrl={optionsEndpoints.admin.location}
          name="locationId"
          value={query?.locationId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<AdminSpaceUsageSearchParams>
          label="Buyer"
          requestUrl={optionsEndpoints.admin.account.buyer}
          name="buyerAccountId"
          value={query?.buyerAccountId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<AdminSpaceUsageSearchParams>
          label="Supplier"
          requestUrl={optionsEndpoints.admin.account.supplier}
          name="supplierAccountId"
          value={query?.supplierAccountId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundDatePicker<AdminSpaceUsageSearchParams>
            label="Start Date"
            name="startDate"
            value={query?.startDate}
            onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundDatePicker<AdminSpaceUsageSearchParams>
            label="End Date"
            name="endDate"
            value={query?.endDate}
            onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundDurationTypeSelect<AdminSpaceUsageSearchParams>
          name="durationType"
          value={query?.durationType}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundTextInput<AdminSpaceUsageSearchParams>
          label="Booking Number"
          name="bookingNumber"
          value={query?.bookingNumber}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundTextInput<AdminSpaceUsageSearchParams>
          label="Overage Invoice Number"
          numeric
          name="overageInvoiceNumber"
          value={query?.overageInvoiceNumber}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundSortSelect<AdminSpaceUsageSearchParams, AdminSpaceUsageSortByType>
          query={query}
          defaultSortBy="CALENDAR_DATE"
          defaultSortDir="desc"
          sortByFields={sortByFields}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
  </SortFilterContainer>
}

export { AdminSpaceUsageSortFilter };